<app-form-grop>
  <span
    label
    i18n="@@upload"
  >Hochladen</span>
  <div class="form-control">
    <input
      input
      type="file"
      accept="application/pdf"
      (change)="onUpload($event)"
    />
  </div>
</app-form-grop>
<app-form-grop *ngIf="presentations && presentations.length > 0">
  <span
    label
    i18n="@@existing-files"
  >Vorhandene Datein</span>
  <app-file-list
    (deleteFile)="this.deletePresentation($event)"
    [presentations]="presentations"
  ></app-file-list>
</app-form-grop>